module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('wx-open-launch-weapp', {
    attrs: {
      "id": "launch-btn",
      "username": _vm.username,
      "path": _vm.path
    },
    on: {
      "launch": _vm.handleLaunchFn,
      "error": _vm.handleErrorFn
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n      <style>.btn { display: flex;align-items: center;width: 200px;height: 200px }</style>\n      <button class=\"btn\">点击进入小程序</button>\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a8574db","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/littleAssistant/littleAssistant.vue
// module id = 829
// module chunks = 0